
const isNullish = (obj) => Object.values(obj).every(value => {
    if (value === null) {
      return true;
    }
    return false;
});

// const getProductInfo = async (skuId, customerID, userName, userPassword) =>{ 
const getProductInfo = async (skuId, customerID) =>{ 
  var myHeaders = new Headers();
  // myHeaders.append("Authorization", "Bearer "+ btoa(btoa(userName+':'+userPassword)));
  
  var requestOptions = {
    method: 'GET',
    // headers: myHeaders,
    "mode": "cors",
    redirect: 'follow',
  };  
  const response = await fetch(`https://rapi.avalonsolution.com/api/SingleProductData?customerid=${customerID}&itemcd=${skuId}`, requestOptions);
  const productinfoRes = await response.json();
  return productinfoRes.data[0];
  
};
const show = (data) => {
  
  	//-------- Jewelry Attributes Info Start----------------
  	const metalInfoObj = Object.keys(data).filter((key) => (key=='Metal_Karat') || (key=='Metal_Color')|| (key=='Metal_Wt_Gms_Appx')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});  
  	const centerStoneInfoObj = Object.keys(data).filter((key) => (key=='Stone_Type') || (key=='Stone_Shape') || (key=='Stone_Color') || (key=='Stone_Quality_Avg')  || (key=='Stone_Ct_MM_Size_Appx') || (key=='Stone_Size_Range') || (key=='Stone_Clarity')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const sideDiamondInfoObj = Object.keys(data).filter((key) => (key=='Diamond_Clarity') || (key=='Diamond_Color') || (key=='Diamond_Ct_Wt_Appx') || (key=='Diamond_Shape') || (key=='No_of_Diamonds_Appx')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const sideColorStoneInfoObj = Object.keys(data).filter((key) => (key=='Color_Stone_Type') || (key=='Color_Stone_Shape') || (key=='Color_Stone_Size_Appx') || (key=='Color_Stone_Qlty_Avg')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const otherInfoObj = Object.keys(data).filter((key) => (key=='Total_Diamond_Wt_Appx') || (key=='Chain_Type')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	
	//-------- Watch Attributes Info Start----------------
  	const watchInfoObj = Object.keys(data).filter((key) => (key=='Watch_Type') || (key=='Model_Number') || (key=='Gender_2')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
    const dialInfoObj = Object.keys(data).filter((key) => (key=='Dial_Material') || (key=='Dial_Color') || (key=='Subdial')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const caseInfoObj = Object.keys(data).filter((key) => (key=='Case_Material') || (key=='Case_Color') || (key=='Case_Diameter')  || (key=='Case_Thickness')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const bandInfoObj = Object.keys(data).filter((key) => (key=='Band_Material') || (key=='Band_Color') || (key=='Band_Length')  || (key=='Band_Width') || (key=='Band_Type')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const watchOtherInfoObj = Object.keys(data).filter((key) => (key=='Movement') || (key=='Functions') || (key=='Water_Resistance')  || (key=='Calendar') || (key=='Made_In') || (key=='Warranty_Type') || (key=='Warranty_Description') || (key=='Clasp_Type_2')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  
  	//-------- Gift Attributes Info Start----------------
  	const giftDetailInfoObj = Object.keys(data).filter((key) => (key=='Gift_Type') || (key=='Gender_3')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
    const materialColorInfoObj = Object.keys(data).filter((key) => (key=='Material_1') || (key=='Material_2') || (key=='Color_1') || (key=='Color_2')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  	const giftBrandInfoObj = Object.keys(data).filter((key) => (key=='Dimension') || (key=='Weight') || (key=='Finish') || (key=='Made_In_2') || (key=='Warranty_Type_2') || (key=='Warranty_Description_2')).reduce((cur, key) => { return Object.assign(cur, { [key]: data[key] })}, {});
  
  
  	//--------Common collection for Attributes ---------------- 
    var attrWithTitle = [{objName: metalInfoObj, title:'Metal Info'},
                         {objName: centerStoneInfoObj, title:'Center Stone Info'},
                         {objName: sideDiamondInfoObj, title:'Side Diamond Info'},
                         {objName: sideColorStoneInfoObj, title:'Side Color Stone Info'},
                         {objName: otherInfoObj, title:'Other Info'},                       
                         {objName: watchInfoObj, title:'Watch Info'},
                         {objName: dialInfoObj, title:'Dial Info'},
                         {objName: caseInfoObj, title:'Case Info'},
                         {objName: bandInfoObj, title:'Band Info'},
                         {objName: watchOtherInfoObj, title:'Watch Other Info'},
                         {objName: giftDetailInfoObj, title:'Gift Detail Information'},
                         {objName: materialColorInfoObj, title:'Material / Color Info'},
                         {objName: giftBrandInfoObj, title:'Gift Brand Information'}
                      	]	
  	
  	var info = ``;
   //  for(productAttr of attrWithTitle){
   //    if(!isNullish(productAttr.objName)){
   //      info += `<div class="col-sm-3">
			// <h5 style="margin-bottom: 0.5em;">${productAttr.title}</h5>
   //          <table class="data table additional-attributes" id="product-attribute-specs-table-${productAttr.title.toLowerCase().replace(/\s+/g, '-')}">`
   //          for (const property in productAttr.objName) {            
   //            if(!!productAttr.objName[property])
   //            info += `<tr><th class="col label" scope="row">${property.split("_").join(" ")}</th>  <td class="col data">${productAttr.objName[property]}</td> </tr>`
   //          }
   //          info += `</table></div>`
   //    }	
   //  }

for (productAttr of attrWithTitle) {
    if (!isNullish(productAttr.objName)) {
        let tableHTML = `<table class="data table additional-attributes" id="product-attribute-specs-table-${productAttr.title.toLowerCase().replace(/\s+/g, '-')}">`;
        let tableHasData = false;

        for (const property in productAttr.objName) {
            if (!!productAttr.objName[property]) {
                tableHTML += `<tr><th class="col label" scope="row">${property.split("_").join(" ")}</th><td class="col data">${productAttr.objName[property]}</td></tr>`;
                tableHasData = true;
            }
        }

        tableHTML += `</table>`;

        // Check if the table has data
        if (!tableHasData) {
            info += `<div class="col-sm-3" style="display: none;">`;
        } else {
            info += `<div class="col-sm-3">`;
        }

        info += `<h5 style="margin-bottom: 0.5em;">${productAttr.title}</h5>`;
        info += tableHTML;
        info += `</div>`;
    }
}

	// Setting innerHTML as tab variable
  	var productInfoCotainer = document.getElementById('product-info');
	productInfoCotainer.innerHTML = info;
};

(function(){
  var customerID = "DANASFINEJEWELRY";
  const skuId = document.querySelector('input[name="products-sku"]').value;
  //console.log(skuId)
  getProductInfo(skuId, customerID).then((productInfo)=>{
    if(productInfo)
    show(productInfo);
  });
})();

